<template>
	<div
		class="user-assign-select-footer"
		:class="`user-assign-select-footer--${variant}`"
	>
		<SuiButton
			v-if="hasActiveRoleFilter"
			class="user-assign-select-footer__remove-role"
			@click.stop="$emit('remove-role')"
		>
			{{ $t('user_assign_select_unassign_role') }}
		</SuiButton>
		<div
			v-else-if="isApplyBlockVisible"
			class="user-assign-select-footer__actions"
		>
			<div
				v-if="isNotifyEnabled"
				class="user-assign-select-footer__notify"
			>
				<SuiCheckbox
					:model-value="shouldNotify"
					@update:model-value="$emit('update:should-notify', $event)"
				>
					{{ $t('notify') }}
				</SuiCheckbox>
			</div>
			<SuiButton
				variant="primary"
				class="user-assign-select-footer__apply"
				@click="$emit('assign-users')"
			>
				{{ $t('apply') }}
			</SuiButton>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { SuiCheckbox, SuiButton } from '@developers/scoro-ui';
import type { ValueOf } from '@/types';
import { UserAssignSelectFooterVariant } from '../../constants';
import type { UserAssignSelectRole } from '../../types';

export interface UserAssignSelectFooterProps {
	isNotifyEnabled?: boolean;
	shouldNotify?: boolean;
	activeRoleFilterId: UserAssignSelectRole['id'] | null;
	isApplyAndNotifyVisible?: boolean;
	variant?: ValueOf<typeof UserAssignSelectFooterVariant>;
}

const {
	isNotifyEnabled = false,
	activeRoleFilterId,
	isApplyAndNotifyVisible = true,
	variant = UserAssignSelectFooterVariant.DEFAULT,
} = defineProps<UserAssignSelectFooterProps>();

const hasActiveRoleFilter = computed(() => activeRoleFilterId !== null);

const isApplyBlockVisible = computed(() =>
	variant === UserAssignSelectFooterVariant.INLINE
		? isApplyAndNotifyVisible
		: true
);

defineEmits<{
	'update:should-notify': [value: boolean];
	'assign-users': [];
	'remove-role': [];
}>();
</script>

<style lang="scss" scoped>
.user-assign-select-footer {
	display: flex;
	justify-content: center;
	width: 100%;

	&__remove-role {
		--sui-button-background-color: #{$red-10};
		--sui-button-hover-background-color: #{$red-20};

		color: #{$red-90};
	}

	&__actions {
		display: grid;
		width: 100%;
		grid-template-columns: 1fr auto 1fr;
		align-items: center;
	}

	&__apply {
		grid-column: 2;
	}

	&__notify {
		justify-self: flex-start;
	}

	&--inline {
		margin-bottom: 1.5rem;
	}
}
</style>
